<template>
    <!-- <b-modal title="Scheda Mobilità" ref="mdlRsaSchedaAreaMobilita" @ok="onSalvaAreaMobilita" @hidden="onCloseModal" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg"> -->
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Valutazione" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Autonomia nella mobilità</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.mobilitaAutonoma }}</span>
                        <b-form-select v-else v-model="jsonDataAreaMobilita.mobilitaAutonoma" :disabled="isReadOnly" :options="mobilitaAutonomaOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Equilibrio</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.equilibrio }}</span>
                        <b-form-select v-else v-model="jsonDataAreaMobilita.equilibrio" :disabled="isReadOnly" :options="equilibrioOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Controllo del tronco</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.controlloTronco }}</span>
                        <b-form-select v-else v-model="jsonDataAreaMobilita.controlloTronco" :disabled="isReadOnly" :options="controlloTroncoOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tono</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.tono }}</span>
                        <b-form-select v-else v-model="jsonDataAreaMobilita.tono" :disabled="isReadOnly" :options="tonoOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Trasferimenti e cambi di postura</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.trasferimentiCambiPostura }}</span>
                        <b-form-select v-else v-model="jsonDataAreaMobilita.trasferimentiCambiPostura" :disabled="isReadOnly" :options="trasferimentiCambiPosturaOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Dolore</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.dolore }}</span>
                        <b-form-select v-else v-model="jsonDataAreaMobilita.dolore" :disabled="isReadOnly" :options="doloreOptions">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Sede del dolore</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.sedeDolore }}</span>
                        <b-form-input v-else v-model="jsonDataAreaMobilita.sedeDolore" :readonly="isReadOnly" :disabled="jsonDataAreaMobilita.dolore !== 'SI' || isReadOnly"> </b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label v-if="isReadOnly" class="sa-label-data">Intensità del dolore: </label>
                        <label v-else class="sa-label-data">Intensità del dolore: {{ jsonDataAreaMobilita.intensitaDolore }}</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.intensitaDolore }}</span>
                        <b-form-input v-else v-model="jsonDataAreaMobilita.intensitaDolore" :disabled="jsonDataAreaMobilita.dolore !== 'SI' || isReadOnly" type="range" min="0" max="10" step="1">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona opzione - </b-form-select-option>
                            </template>
                        </b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <span v-if="isReadOnly">{{ jsonDataAreaMobilita.note }}</span>
                        <b-form-textarea v-else v-model="jsonDataAreaMobilita.note" :readonly="isReadOnly" max-rows="10" rows="7"></b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
    <!-- <template #modal-footer>
            <b-button v-if="!isReadOnly" variant="outline-danger" @click="$refs.mdlRsaSchedaAreaMobilita.hide()">Annulla</b-button>
            <b-button v-if="!isReadOnly" variant="outline-success" @click="onSalvaAreaMobilita()">Salva</b-button>
            <b-button v-if="isReadOnly" variant="outline-primary" @click="$refs.mdlRsaSchedaAreaMobilita.hide()"> Chiudi </b-button>
        </template>
    </b-modal> -->
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        jsonDataAreaMobilita: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    mobilitaAutonoma: null,
                    equilibrio: null,
                    controlloTronco: null,
                    tono: null,
                    trasferimentiCambiPostura: null,
                    dolore: null,
                    sedeDolore: "",
                    intensitaDolore: 0,
                    note: "",
                };
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    mounted() {
        let me = this;

        if (me.idRisorsa !== null) {
            me.visualizzaAreaMobilita();
        }
    },
    watch: {
        jsonDataAreaMobilita: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceAreaMobilita: "/rsaareamobilita",
            pathResourceCheckAreaMobilita: "/rsaareamobilita/check",
            intensitaDoloreOptions: [
                { text: "1", value: "1" },
                { text: "2", value: "2" },
                { text: "3", value: "3" },
                { text: "4", value: "4" },
                { text: "5", value: "5" },
                { text: "6", value: "6" },
                { text: "7", value: "7" },
                { text: "8", value: "8" },
                { text: "9", value: "9" },
                { text: "10", value: "10" },
            ],
            mobilitaAutonomaOptions: [
                { text: "NORMALE", value: "NORMALE" },
                { text: "SUPERVISIONE", value: "SUPERVISIONE" },
                { text: "ASSISTENZA", value: "ASSISTENZA" },
                { text: "NON DEAMBULANTE", value: "NON DEAMBULANTE" },
            ],
            equilibrioOptions: [
                { text: "STABILE", value: "INSTABILE" },
                { text: "INSTABILE", value: "INSTABILE" },
            ],
            controlloTroncoOptions: [
                { text: "SEDUTO", value: "SEDUTO" },
                { text: "STAZIONE ERETTA", value: "STAZIONE ERETTA" },
                { text: "NO CONTROLLO", value: "NO CONTROLLO" },
            ],
            tonoOptions: [
                { text: "NORMOTONICO", value: "NORMOTONICO" },
                { text: "IPOTONICO", value: "IPOTONICO" },
                { text: "IPERTONICO", value: "IPERTONICO" },
            ],
            trasferimentiCambiPosturaOptions: [
                { text: "AUTONOMO", value: "AUTONOMO" },
                { text: "NON AUTONOMO", value: "NON AUTONOMO" },
            ],
            doloreOptions: [
                { text: "SI", value: "SI" },
                { text: "NO", value: "NO" },
            ],

            /* jsonDataAreaMobilita: {
                id: null,
                idAccettazione: null,
                mobilitaAutonoma: null,
                equilibrio: null,
                controlloTronco: null,
                tono: null,
                trasferimentiCambiPostura: null,
                dolore: null,
                sedeDolore: null,
                intensitaDolore: null,
                note: null,
            }, */
        };
    },

    methods: {
        visualizzaAreaMobilita() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourceAreaMobilita + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            /*   me.jsonDataAreaMobilita = response.data.data; */
            Object.keys(response.data.data).forEach((key) => {
                me.jsonDataAreaMobilita[key] = response.data.data[key];
            });
            me.$emit("afterLoadData");
            // console.log("LOAD DATA SUCCESS: ", me.jsonDataAreaMobilita);
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onCloseModal() {
            let me = this;
            me.jsonDataAreaMobilita = {};
            me.$emit("onClose");
        },
        onSalvaAreaMobilita() {
            let me = this;
            if (!me.jsonDataAreaMobilita.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceAreaMobilita, me.jsonDataAreaMobilita, me.saveAreaMobilitaSuccessResponse, me.saveAreaMobilitaErrorResponse);
        },
        saveAreaMobilitaSuccessResponse() {
            let me = this;
            me.$emit("afterSaveSuccess");
            me.$refs.mdlRsaSchedaAreaMobilita.hide();
            /*  console.log("idAccettazione: ", me.jsonDataSchedaSocialePaziente.idAccettazione); */ //PERCHE SE LO USO MI VA IN ERRORE E NON MI TROVA RESPONSE.
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveAreaMobilitaErrorResponse(response) {
            if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-secondary",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                this.$bvToast.toast("Errore nel salvataggio in edit component" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        /*      nuovaAreaMobilita() {
            let me = this;
            me.isReadOnly = false;
            UtilityMixin.methods.loadDataResources(me.pathResourceAreaMobilita, { idAccettazione: me.idAccettazione }, me.loadAreaMobilitaDataSuccess, me.loadAreaMobilitaDataError);
        },
        loadAreaMobilitaDataSuccess(response) {
            let me = this;
            if (response.data.data.list.length > 0) {
                me.jsonDataAreaMobilita = response.data.data.list[0];
            } else {
                me.jsonDataAreaMobilita = {
                    id: null,
                    idAccettazione: me.idAccettazione,
                    mobilitaAutonoma: null,
                    equilibrio: null,
                    controlloTronco: null,
                    tono: null,
                    trasferimentiCambiPostura: null,
                    dolore: null,
                    sedeDolore: null,
                    intensitaDolore: null,
                    note: null,
                };
            }
            // me.$refs.mdlRsaSchedaAreaMobilita.show();
        }, */
        /* loadAreaMobilitaDataError(error) {
            let me = this;
            console.error("Errore nel caricamento dei dati: ", error);
            me.jsonDataAreaMobilita = {
                id: null,
                idAccettazione: me.idAccettazione,
                mobilitaAutonoma: "",
                equilibrio: "",
                controlloTronco: "",
                tono: "",
                trasferimentiCambiPostura: "",
                dolore: "",
                sedeDolore: "",
                intensitaDolore: "",
                note: "",
            };
            me.$refs.mdlRsaSchedaAreaMobilita.show();
        }, */
    },
};
</script>
